// extracted by mini-css-extract-plugin
export default {"container":"ScheduleChip_container__W5zNL","icon":"ScheduleChip_icon__KmXHX","label":"ScheduleChip_label__koptn","close":"ScheduleChip_close__7BWKX"};